<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-7 inline">
          <h4>
            <h2 style="display: inline">Overview</h2>
          </h4>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3">
          <h4>
            Select Site:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.site"
              @change="getSite()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-3">
          <h4>
            Select Line:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.line"
              @change="getSite()"
            >
              <el-option
                v-for="option in selects.lines"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <card card-body-classes="table-full-width">
            <template slot="header">
              <h3 class="card-title">
                <i class="fa fa-bell text-info"></i>
                <b>&nbsp; Incinerator</b>
              </h3>
            </template>
            <!-- collection of image -->
            <div>
              <!-- pangkor line A -->
              <div v-if="selects.site == '04' && selects.line == 7">
                <div :style="maindiv">
                  <!-- gambar -->
                  <img
                    src="@/assets/img/overview/SCADA PP Line A.jpg"
                    width="1100px"
                  />
                  <div v-for="(item, index) in datas" :key="index">
                    <!-- BATE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BATE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 195px;
                          left: 170px;
                          right: 0;
                          height: 26px;
                          width: 55px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BAFN01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BAFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 101px;
                          left: 365px;
                          right: 0;
                          height: 28px;
                          width: 55px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 310px;
                          left: 888px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CAPT02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CAPT02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 32px;
                          left: 783px;
                          right: 0;
                          height: 30px;
                          width: 55px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CATE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CATE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 130px;
                          left: 589px;
                          right: 0;
                          height: 28px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCDC01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCDC01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 165px;
                          left: 633px;
                          right: 0;
                          height: 28px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCFN01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 307px;
                          left: 972px;
                          right: 0;
                          height: 29px;
                          width: 63px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCFN02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCFN02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 228px;
                          left: 971px;
                          right: 0;
                          height: 29px;
                          width: 63px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCPT02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 352px;
                          left: 547px;
                          right: 0;
                          height: 26px;
                          width: 56px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCDC02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCDC02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 165px;
                          left: 508px;
                          right: 0;
                          height: 28px;
                          width: 52px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 352px;
                          left: 681px;
                          right: 0;
                          height: 26px;
                          width: 49px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 234px;
                          left: 902px;
                          right: 0;
                          height: 25px;
                          width: 49px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- BATE02 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BATE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 236px;
                          left: 213px;
                          right: 0;
                          height: 26px;
                          width: 51px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- CAPU02 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CAPU02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 129px;
                          left: 911px;
                          right: 0;
                          height: 28px;
                          width: 60px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCPT04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 259px;
                          left: 902px;
                          right: 0;
                          height: 26px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BAFN03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BAFN03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 37px;
                          left: 360px;
                          right: 0;
                          height: 30px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 381px;
                          left: 547px;
                          right: 0;
                          height: 28px;
                          width: 56px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- BARD01 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BARD01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 195px;
                          left: 291px;
                          right: 0;
                          height: 28px;
                          width: 61px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CATE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CATE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 60px;
                          left: 600px;
                          right: 0;
                          height: 30px;
                          width: 56px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BAPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BAPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 113px;
                          left: 160px;
                          right: 0;
                          height: 28px;
                          width: 81px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- CAPU01 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CAPU01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 65px;
                          left: 904px;
                          right: 0;
                          height: 29px;
                          width: 64px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CATE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CATE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 130px;
                          left: 534px;
                          right: 0;
                          height: 28px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCPT03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 348px;
                          left: 733px;
                          right: 0;
                          height: 28px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BATE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BATE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 235px;
                          left: 379px;
                          right: 0;
                          height: 26px;
                          width: 57px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CAPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CAPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 140px;
                          left: 797px;
                          right: 0;
                          height: 26px;
                          width: 57px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CATE05 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CATE05'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 130px;
                          left: 644px;
                          right: 0;
                          height: 28px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BATE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BATE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 324px;
                          left: 201px;
                          right: 0;
                          height: 28px;
                          width: 69px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- pangkor line B -->
              <div v-if="selects.site == '04' && selects.line == 8">
                <div :style="maindiv">
                  <!-- gambar -->
                  <img
                    src="@/assets/img/overview/SCADA PP Line B.jpg"
                    width="1100px"
                  />
                  <div v-for="(item, index) in datas" :key="index">
                    <!-- BBPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 152px;
                          left: 231px;
                          right: 0;
                          height: 29px;
                          width: 77px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBFN01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 153px;
                          left: 436px;
                          right: 0;
                          height: 28px;
                          width: 61px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBPT02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBPT02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 2px;
                          left: 479px;
                          right: 0;
                          height: 30px;
                          width: 79px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 2px;
                          left: 842px;
                          right: 0;
                          height: 30px;
                          width: 77px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCPT06 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT06'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 83px;
                          left: 721px;
                          right: 0;
                          height: 30px;
                          width: 58px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 367px;
                          left: 291px;
                          right: 0;
                          height: 30px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 286px;
                          left: 287px;
                          right: 0;
                          height: 29px;
                          width: 51px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 2px;
                          left: 702px;
                          right: 0;
                          height: 29px;
                          width: 54px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBFN01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 3px;
                          left: 1035px;
                          right: 0;
                          height: 30px;
                          width: 62px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- DCPT07 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT07'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 84px;
                          left: 921px;
                          right: 0;
                          height: 30px;
                          width: 58px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- DCTE06 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE06'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 115px;
                          left: 721px;
                          right: 0;
                          height: 30px;
                          width: 58px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE07 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE07'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 115px;
                          left: 921px;
                          right: 0;
                          height: 30px;
                          width: 58px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCPT05 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT05'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 388px;
                          left: 620px;
                          right: 0;
                          height: 29px;
                          width: 65px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBFN02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBFN02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 43px;
                          left: 1035px;
                          right: 0;
                          height: 30px;
                          width: 62px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 274px;
                          left: 165px;
                          right: 0;
                          height: 28px;
                          width: 53px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCTE08 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCTE08'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 194px;
                          left: 761px;
                          right: 0;
                          height: 28px;
                          width: 58px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBFN02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBFN02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 350px;
                          left: 464px;
                          right: 0;
                          height: 28px;
                          width: 61px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- DCPT08 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCPT08'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 82px;
                          left: 790px;
                          right: 0;
                          height: 30px;
                          width: 60px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBRD01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBRD01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 244px;
                          left: 367px;
                          right: 0;
                          height: 26px;
                          width: 60px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- BBTE01 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 243px;
                          left: 247px;
                          right: 0;
                          height: 26px;
                          width: 52px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- DCFN01 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 313px;
                          left: 983px;
                          right: 0;
                          height: 29px;
                          width: 62px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                     <!-- CBTE01 -->
                     <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 76px;
                          left: 579px;
                          right: 0;
                          height: 30px;
                          width: 53px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DCFN02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DCFN02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 243px;
                          left: 982px;
                          right: 0;
                          height: 29px;
                          width: 62px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                  </div>

                </div>
              
              </div>
              <!-- cameron highland line A -->
              <div v-if="selects.site == '03' && selects.line == 5">
                <div :style="maindiv">
                  <!-- gambar -->
                  <img
                    src="@/assets/img/overview/SCADA CH Line A.jpg"
                    width="1100px"
                  />
                  <div v-for="(item, index) in datas" :key="index">
                    <!-- VFD rotary klin -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'VFD' && item.instrument == 'Rotary Klin'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 335px;
                          left: 310px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- VFD Water Quench -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'VFD' && item.instrument == 'Water Quencher'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 194px;
                          left: 353px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-502 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-502'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 405px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-501B Secondary Combustion Chamber -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-501B' && item.instrument == 'Secondary Combustion Chamber'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 210px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-501B Water Quencher -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-501B' && item.instrument == 'Water Quencher'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 91px;
                          left: 585px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-401B -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-401B'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 250px;
                          left: 595px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-502B -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-502B'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 455px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-301B -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-301B'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 190px;
                          left: 203px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-401A -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-401A'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 225px;
                          left: 538px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DP-701 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DP-701'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 130px;
                          left: 835px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- PT-401 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'PT-401'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 221px;
                          left: 470px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DP-601 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DP-601'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 20px;
                          left: 540px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-504 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-504'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 115px;
                          left: 215px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-701 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-701'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 47px;
                          left: 965px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DP-501 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DP-501'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 355px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-501A SCC-->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-501A' && item.instrument == 'Secondary Combustion Chamber'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 118px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-501A water quencher -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-501A' && item.instrument == 'Water Quencher'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 70px;
                          left: 528px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-702 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-702'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 6px;
                          left: 980px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-503 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-503'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 32px;
                          left: 3px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- PT-501 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'PT-501'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 73px;
                          left: 3px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-301A -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-301A'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 188px;
                          left: 136px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- TT-505 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'TT-505'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 34px;
                          left: 286px;
                          right: 0;
                          height: 23px;
                          width: 50px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- cameron highland line B -->
              <div v-if="selects.site == '03' && selects.line == 6">
                <div :style="maindiv">
                  <!-- gambar -->
                  <img
                    src="@/assets/img/overview/SCADA CH Line B.jpg"
                    width="1280px"
                  />
                  <div v-for="(item, index) in datas" :key="index">
                    <!-- BBTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 164px;
                          left: 728px;
                          right: 0;
                          height: 23px;
                          width: 40px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBTE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 161px;
                          left: 882px;
                          right: 0;
                          height: 23px;
                          width: 40px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 164px;
                          left: 687px;
                          right: 0;
                          height: 23px;
                          width: 40px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 315px;
                          left: 820px;
                          right: 0;
                          height: 23px;
                          width: 40px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBPT02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBPT02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 196px;
                          left: 955px;
                          right: 0;
                          height: 23px;
                          width: 44px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 196px;
                          left: 903px;
                          right: 0;
                          height: 23px;
                          width: 44px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 252px;
                          left: 820px;
                          right: 0;
                          height: 23px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 284px;
                          left: 820px;
                          right: 0;
                          height: 24px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBPT03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBPT03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 370px;
                          left: 191px;
                          right: 0;
                          height: 27px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBTE01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBTE01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 327px;
                          left: 630px;
                          right: 0;
                          height: 27px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBTE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBTE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 380px;
                          left: 260px;
                          right: 0;
                          height: 27px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBPT01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBPT01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 305px;
                          left: 970px;
                          right: 0;
                          height: 27px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBTE03 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE03'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 290px;
                          left: 1045px;
                          right: 0;
                          height: 27px;
                          width: 41px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBPT02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBPT02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 258px;
                          left: 383px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBTE02 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBTE02'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 320px;
                          left: 383px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- DBFN01 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'DBFN01'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 380px;
                          left: 130px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- BBTE05 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'BBTE05'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 80px;
                          left: 200px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                    <!-- CBTE04 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      v-if="item.label == 'CBTE04'"
                    >
                      <div slot="content" style="text-align: center">
                        <p>{{ item.label }}</p>
                        <p>{{ item.value }} {{ item.unit }}</p>
                        <p>Last read {{ item.lastread }}</p>
                      </div>
                      <div
                        style="
                          border-radius: 5px;
                          position: absolute;
                          top: 265px;
                          left: 969px;
                          right: 0;
                          height: 27px;
                          width: 43px;
                          background-color: rgb(255, 255, 255);
                        "
                      >
                        <p
                          style="
                            font-size: 8px;
                            color: #000000;
                            text-align: center;
                            font-weight: bold;
                          "
                        >
                          {{ item.label }} <br />{{ item.value }}
                          {{ item.unit }}
                        </p>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <card card-body-classes="table-full-width">
            <template slot="header">
              <h3 class="card-title">
                <i class="fa fa-bell text-info"></i>
                <b>&nbsp; Historical Alarm</b>
              </h3>
            </template>
            <div class="row">
           
              <div class="col-lg-4 style-date">
                <h4>
                  Select Date Range
                  <el-date-picker
                    v-model="selects.date"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    @change="getSite()"
                  ></el-date-picker>
                </h4>
              </div>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <div id="tableku">
              <el-table
                :data="queriedData"
                style="width: 100%"
                height="380"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  v-for="column in deviceColumns"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  width="240"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              ></base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { Table, TableColumn } from "element-ui";
import { Select, Option, DatePicker, Tooltip } from "element-ui";
import { Modal, BasePagination, BaseSwitch } from "src/components";
import Fuse from "fuse.js";
import { Circle8 } from "vue-loading-spinner";
import swal from "sweetalert2";
import * as XLSX from "sheetjs-style";
import { read, utils, writeFile } from "xlsx";
import moment from "moment";
import { debounce } from "src/util/debounce";

export default {
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      screenWidth: "",
      maindiv: "",
        // "position: absolute;top: 200px;left: 87px; right: 0;height: 234px;width: 200px;background-color: rgb(154, 0, 0, 0.5);",

      deviceColumns: [
        {
          prop: "timelct",
          label: "Time",
        },
        {
          prop: "priority",
          label: "Priority",
        },
        {
          prop: "state",
          label: "State",
        },
        {
          prop: "node",
          label: "Node",
        },
        {
          prop: "group",
          label: "Group",
        },
        {
          prop: "tagname",
          label: "Tag Name",
        },
        {
          prop: "description",
          label: "Description",
        },
        {
          prop: "type",
          label: "Type",
        },
        {
          prop: "limit",
          label: "Limit",
        },
        {
          prop: "currentvalue",
          label: "Current Value",
        },
        {
          prop: "alarmduration",
          label: "Alarm Duration",
        },
        {
          prop: "operator",
          label: "Operator",
        },
        {
          prop: "unackduration",
          label: "UnAckDuration",
        },
      ],
      apiUrl: "",

      // Selecting interval data
      selects: {
        site: "03",
        sites: [
          { value: "03", label: "Pulau Pangkor" },
          { value: "04", label: "Cameron Highlands" },
        ],
        time: "daily",
        times: [
          { value: "daily", label: "Daily" },
          { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
          { value: "yearly", label: "Yearly" },
        ],
        line: "",
        lines: [],
        date: [],
      },
      tableDatas: [],
      temp: [],
      searchedData: [],
      fuseSearch: null,
      searchQuery: "",

      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      flexwidth: "",
      datas: [],
    };
  },
  created() {
    this.selects.date = [moment().startOf("M"), moment()]
    this.getdestination();
  },
  watch: {
    searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter((value) =>
          value.timelct.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
    "selects.site"() {
      this.getline();
      this.getOverview();
    },
    "selects.line"() {
      this.getOverview();
    },
    screenWidth() {
    console.log(this.screenWidth )
      if (parseInt(this.screenWidth) >= 1541) {
        // monitor
        this.maindiv =
          "position: relative;max-width: 1100px;display: block;margin-left: auto;margin-right: auto;";
      }
      if (parseInt(this.screenWidth) <= 1540) {
        // laptop
        this.maindiv =
          "position: relative;max-width: 1100px;display: block;margin-left: auto;margin-right: auto;";
      }
      
    },
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    this.getSite();

    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["description"],
      threshold: 0.3,
    });
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  methods: {
    getOverview() {
      this.datas = [];
      if (this.selects.site != "" && this.selects.line != "") {
        this.$http
          .get(
            ":9999/api/v1/incinerator/data?destination_code=" +
              this.selects.site +
              "&incinerator_id=" +
              this.selects.line
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              for (var i = 0; i < response.length; i++) {
                let obj = {
                  label: response[i].label,
                  value: response[i].value,
                  unit: response[i].unit_of_measurement,
                  lastread: moment(response[i].read_at).fromNow(),
                  instrument: response[i].instrument_name

                };
                this.datas.push(obj);
              }
            }
          });
      }
    },
    getline() {
      this.selects.lines = [];

      this.$http
        .get(
          ":9999/api/v1/setting/incinerator?destination_code=" +
            this.selects.site
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].incinerator_code,
                value: response[i].incinerator_id,
              };

              this.selects.lines.push(obj);
            }

            this.selects.line = this.selects.lines[0].value;
          }
        });
    },
    getdestination() {
      this.selects.sites = [];

      this.$http.get(":9999/api/v1/setting/destination").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].destination_name,
              value: response[i].destination_code,
            };
            this.selects.sites.push(obj);
          }
          this.getline();
          this.selects.site = this.selects.sites[0].value;
        }
      });
    },
    getSite() {
      this.temp = []
      this.tableDatas = [];
      this.getDatas();
    },

    async getDatas() {
      // Create default date range (e.g., last 7 days)
      const defaultStartDate = moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      const defaultEndDate = moment().format("YYYY-MM-DD");

      // Check if selects.date has the default value
      const isDefaultDate =
        moment(this.selects.date[0]).format("YYYY-MM-DD") ===
          defaultStartDate &&
        moment(this.selects.date[1]).format("YYYY-MM-DD") === defaultEndDate;

      // Use default or selected dates based on whether the default value is selected or not
      let start = isDefaultDate
        ? defaultStartDate
        : moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = isDefaultDate
        ? defaultEndDate
        : moment(this.selects.date[1]).format("YYYY-MM-DD");

      // if (this.selects.time === "daily") {
        // this.apiUrl = `:9999/api/v1/alarm/weekly?destination_code=${this.selects.site}&date=${start}`;
      // } else {
        this.apiUrl = `:9999/api/v1/alarm/weekly?destination_code=${this.selects.site}&from=${start}&to=${end}`;
      // }

      this.$http.get(this.apiUrl).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("api being called", response);
          for (let i = 0; i < response.length; i++) {
            var obj = {
              timelct: moment(response[i].time_lct).format("YYYY-MM-DD hh:mm:ss A"),
              priority: response[i].priority,
              state: response[i].state,
              node: response[i].node,
              group: response[i].group,
              tagname: response[i].tag_name,
              description: response[i].description,
              type: response[i].type,
              limit: response[i].limit,
              currentvalue: response[i].current_value,
              alarmduration: response[i].alarm_duration,
              operator: response[i].operator,
              unackduration: response[i].un_act_duration,
            };
            this.tableDatas.push(obj);
            this.temp.push(obj)
          }
        } else {
          console.log("api not being called");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  color: black;
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.photos {
  width: 120px;
  height: 120px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
